import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/home/Home';
import Styleguide from '@/pages/Styleguide';
import PageNotFound from '@/pages/PageNotFound';
import AuthenticationPage from '@/pages/AuthenticationPage';
import MarketsPage from '@/pages/markets/MarketsPage';
import SettingsPage from '@/pages/SettingsPage';

import MarketPage from '@/pages/market/MarketPage';
import VacanciesPage from '@/pages/vacancies/VacanciesPage';
import RecruitmentPage from '@/pages/market/RecruitmentPage';

import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';

import LoginForm from '@/components/auth/forms/LoginForm';
import RegistrationForm from '@/components/auth/forms/RegistrationForm';
import PasswordForm from '@/components/auth/forms/PasswordForm';

import GeneralMenu from '@/components/general/menu/General';
import LogoMenu from '@/components/general/menu/Logo';
import MarketMenu from '@/components/general/menu/Market';

import firebase from 'firebase';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            components: {
                default: Home,
                menu: GeneralMenu
            },
            children: [
                {
                    name: 'Home',
                    path: '',
                    redirect: 'vacancies'
                },
                {
                    name: 'vacancies',
                    path: 'vacancies',
                    components: {
                        default: VacanciesPage,
                        menu: LogoMenu
                    },
                    meta: { auth: false }
                }
            ]
        },
        // {
        //     path: '/manage',
        //     components: {
        //         default: Home,
        //         menu: GeneralMenu
        //     },
        //     children: [
        //         {
        //             name: 'privacy',
        //             path: 'privacy',
        //             components: {
        //                 default: PrivacyPolicy,
        //                 menu: GeneralMenu
        //             },
        //         },
        //         {
        //             name: 'terms-of-service',
        //             path: 'terms-of-service',
        //             components: {
        //                 default: TermsOfService,
        //                 menu: GeneralMenu
        //             },
        //         },
        //         {
        //             path: 'styleguide',
        //             name: 'styleguide',
        //             components: {
        //                 default: Styleguide,
        //                 menu: GeneralMenu
        //             },
        //             meta: { auth: false },
        //         },
        //         {
        //             path: '/',
        //             name: 'markets',
        //             components: {
        //                 default: MarketsPage,
        //                 menu: GeneralMenu
        //             },
        //             meta: { auth: true },
        //         },
        //         {
        //             path: '',
        //             redirect: 'markets'
        //         },
        //         {
        //             path: ':key',
        //             name: 'market-dashboard',
        //             components: {
        //                 default: MarketPage,
        //                 menu: MarketMenu
        //             },
        //             meta: { auth: true }
        //         },
        //         {
        //             path: '/:key/recruitment',
        //             name: 'market-recruitment',
        //             components: {
        //                 default: RecruitmentPage,
        //                 menu: MarketMenu
        //             },
        //             meta: { auth: true }
        //         },
        //         {
        //             path: 'settings',
        //             name: 'settings',
        //             components: {
        //                 default: SettingsPage,
        //                 menu: GeneralMenu
        //             },
        //             meta: { auth: true }
        //         }
        //     ]
        // },
        // {
        //     path: '/auth',
        //     component: AuthenticationPage,
        //     meta: { auth: false },
        //     children: [
        //         {
        //             // UserProfile will be rendered inside User's <router-view>
        //             // when /user/:id/profile is matched
        //             name: 'signin',
        //             path: '/',
        //             component: LoginForm
        //         },
        //         {
        //             // UserPosts will be rendered inside User's <router-view>
        //             // when /user/:id/posts is matched
        //             name: 'register',
        //             path: 'register',
        //             component: RegistrationForm
        //         },
        //         {
        //             name: 'forgotten',
        //             path: 'password/forgotten',
        //             component: PasswordForm
        //         },
        //         {
        //             path: '',
        //             redirect: 'signin'
        //         },
        //     ]
        // },
        {
            path: '/page-not-found',
            name: 'PageNotFound',
            component: PageNotFound
        }
    ],
});

router.beforeEach((to, from, next) => {
    // ...
    // console.log('Auth guard', to, from);
    // if (to.meta.auth && !firebase.auth().currentUser) {
    //     //TODO pass redirect to page.
    //     router.push({name: 'signin'});
    // }
    // //     next();
    // // }

    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js